import React from 'react'
import styled from 'styled-components'
import {
    MainButton,
    StyledModal,
    ModalTopPart,
    ModalTitle,
    ModalMainText,
    ModalButtonsContainer,
} from '@appearance/styled'
import i18n from '@localization/i18n'

export default ({ isOpen, onClose, title, mainText, error }) => {
    return (
        <StyledModal isOpen={isOpen}>
            <ModalTopPart>
                <ModalTitle error={error}>{title}</ModalTitle>
                <ModalMainText>{mainText}</ModalMainText>
            </ModalTopPart>

            <ModalButtonsContainer>
                <StyledMainButton onClick={onClose}>
                    {i18n.t('modals.confirm')}
                </StyledMainButton>
            </ModalButtonsContainer>
        </StyledModal>
    )
}

const StyledMainButton = styled(MainButton)`
    margin: 0 auto;
`
